// extracted by mini-css-extract-plugin
export default {"cont":"Container_cont__tx6qw","innerLayout":"Container_innerLayout__-yxV7"};